<h3>Scanner für Dokumente</h3>
<app-search (searchChanged)="searchChanged($event)" [focusedAsDefault]="false"></app-search>

<nz-divider></nz-divider>

<h3>Scanner für Gutscheine</h3>
<app-search #voucherSearch (searchChanged)="scanVoucher($event)" [focusedAsDefault]="false"></app-search>

<app-process-modal globalModal="productionOrderProcessModalWelcomeCmp" #processModalComponent>
  <span trigger></span>
</app-process-modal>

<app-delivery-note-process-modal globalModal="deliveryNoteProcessModalWelcomeCmp" #deliveryNoteProcessModalComponent></app-delivery-note-process-modal>

<app-storage-place-finder-modal globalModal="storagePlaceFinderModalWelcomeCmp" #storagePlaceFinderModalComponent></app-storage-place-finder-modal>

<app-add-edit-order-modal #addEditOrderModalComponent>
  <span trigger></span>
</app-add-edit-order-modal>

<app-stock-transfer-process-modal globalModal="stockTransferProcessModalCmp" #stockTransferProcessModal>
  <span trigger></span>
</app-stock-transfer-process-modal>

<app-voucher-code-details-modal />
